document.addEventListener("DOMContentLoaded", () => {
  $(document).on("click", "#datatable-filter", function(){
    const target = $("#datatable-filter-content")
    
    if (!target.attr("hidden")) {
      target.attr("hidden", "hidden")
      return
    }

    if (target.html() != "") {
      target.removeAttr("hidden")
      return
    }

    if (!($("input[datatable_filter_paramter]").length)){
      alert("Filter parameter not exist")
      return
    }

    target.html(setSpinner())
    target.removeAttr("hidden")

    const parameter = {}
    
    $("input[datatable_filter_paramter]").each(function(idx, elm){
      parameter[$(elm).attr("name")] = $(elm).val() 
    })

    $.ajax({
      url: window.location.href + "/filter",
      data: parameter,
      dataType: 'script',
      success: function(res) {
        target.html(res)
        $(".filter-select2").select2({})
      },
      error: function (jqXHR) {
        target.attr("hidden", "hidden")
        alert("Something wen't wrong!")
      }
    })
  })

  var timer;
  $(document).on('keyup keydown change', ".custom-table-filter", function () {
    const dom = $(this)
    const val = dom.val().toUpperCase()

    clearTimeout(timer);
    timer = setTimeout(function () {
      if (val.length) {
        $(`#${dom.attr('target')} tbody tr[search]`).attr('hidden', 'hidden')
        const records = $(`#${dom.attr('target')} tbody tr[search*=${val}]`)
        if (records.length) {
          records.removeAttr('hidden')
        }
      } else {
        $(`#${dom.attr('target')} tbody tr[search]`).removeAttr('hidden')
      }
    }, 250);
  })
})